import React, { useEffect, useCallback, useState} from 'react';
import Plane from "components/effects/plane/Plane.js";
import Colors from 'components/Colors.js';
import CirklonEditor from "components/cirklon/CirklonEditor.js";
import StickyLogo from "components/landing/StickyLogo.js";
import Grids from './Grids.js';
import {connect} from 'react-redux';
import SaveButton from './SaveButton.js';
import CombineButton from './CombineButton.js';

const colors = new Colors();

const ExploreWork = ({work, sequencerEngine}) => { 
    let [toggled, setToggled] = useState(false);
    let [selectedTrack, setSelectedTrack] = useState(undefined);
    let _sequencerEngine = sequencerEngine.idToSequencerEngine[work.newSequence];
    if (!_sequencerEngine) {
        return '';
    }
    useEffect(() => {
        if (!toggled) {
            setSelectedTrack(undefined);
        }
    }, [toggled, setSelectedTrack]);

    return (
        <div className="explore-work">
          {toggled && selectedTrack ?
           <CirklonEditor color={colors.getColorForTrack(selectedTrack)} track={selectedTrack}/> : 
           _sequencerEngine.subSequences.map(
               subSequence => 
                   <Grids
                     isExplore={true}
                     setSelectedTrack={setSelectedTrack} toggled={toggled} subSequence={subSequence} sequencerEngine={_sequencerEngine}/>)}
          <StickyLogo setToggled={setToggled} toggled={toggled}/>
          <CombineButton multiSequencerEngine={sequencerEngine} sequencerEngine={_sequencerEngine}/>
          <SaveButton sequencerEngine={_sequencerEngine}/>
        </div>);
};

const mapStateToProps = (state, props) => {
    let _sequencerEngine = props.sequencerEngine.idToSequencerEngine[props.work.newSequence];
    if (!_sequencerEngine) {
        return {};
    }
    return {
        worksLoaded: state.explore.worksLoaded,
        numSubSequences: _sequencerEngine && _sequencerEngine.subSequences.length,
        pulledEffects: state.effects.pulledEffects,
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExploreWork);
